(() => {
  function restoreSample(image) {
    if (!image.matches("img[data-pe-preview]")) return;
    const media = image.closest(".cart-item__media");
    image.removeAttribute("data-pe-preview");
    image.src = image.dataset.fallbackSrc;
    media.querySelector("[data-pe-sample-label]")?.removeAttribute("hidden");
    media.querySelector("[data-pe-preview-label]")?.setAttribute("hidden", "");
  }

  document.addEventListener(
    "error",
    (event) => {
      if (event.target instanceof HTMLImageElement) restoreSample(event.target);
    },
    true,
  );

  document.querySelectorAll("img[data-pe-preview]").forEach((image) => {
    if (image.complete && !image.naturalWidth) restoreSample(image);
  });

  class PeCartDelivery extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector("[data-pe-delivery-date]");
      const start = new Date(`${this.dataset.startDate}T12:00:00Z`);
      const min = Number(this.dataset.minDays);
      const max = Number(this.dataset.maxDays);
      if (
        !target ||
        Number.isNaN(start.getTime()) ||
        !Number.isInteger(min) ||
        !Number.isInteger(max) ||
        min < 0 ||
        max < min ||
        max > 60
      )
        return;
      const addDays = (days) => {
        const date = new Date(start);
        while (days > 0) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (![0, 6].includes(date.getUTCDay())) days--;
        }
        return date;
      };
      const format = new Intl.DateTimeFormat(
        document.documentElement.lang || "en",
        {
          month: "short",
          day: "numeric",
          timeZone: "UTC",
        },
      );
      target.textContent = `${format.format(addDays(min))} – ${format.format(addDays(max))}`;
    }
  }

  class PeCartSticky extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById("MainContent");
      this.total = this.querySelector("[data-pe-sticky-total]");
      this.button = this.querySelector("[data-pe-sticky-checkout]");
      if (!this.main || !this.total || !this.button) return;
      this.label =
        this.button.querySelector("[data-pe-sticky-label]") || this.button;
      this.checkoutLabel = this.label.textContent.trim();
      this.loading = false;
      this.onClick = () => {
        const checkout = document.getElementById("checkout");
        if (
          !checkout ||
          this.loading ||
          this.button.disabled ||
          checkout.disabled
        )
          return;
        if (checkout.form && !checkout.form.reportValidity()) return;
        this.setLoading(true);
        this.loadingTimer = setTimeout(() => this.setLoading(false), 15000);
        try {
          checkout.click();
        } catch (error) {
          this.setLoading(false);
          throw error;
        }
      };
      this.onPageShow = () => this.setLoading(false);
      window.addEventListener("pageshow", this.onPageShow);
      this.button.addEventListener("click", this.onClick);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target)))
          this.schedule();
      });
      this.observer.observe(this.main, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["class", "disabled", "aria-busy"],
      });
      this.intersection = new IntersectionObserver((entries) => {
        this.checkoutVisible = entries[0].isIntersecting;
        this.schedule();
      });
      this.sync();
    }

    setLoading(loading) {
      clearTimeout(this.loadingTimer);
      this.loading = loading;
      this.button.setAttribute("aria-busy", String(loading));
      this.label.textContent = loading
        ? this.button.dataset.loadingLabel || this.checkoutLabel
        : this.checkoutLabel;
      this.sync();
    }

    sync() {
      const checkout = document.getElementById("checkout");
      const items = this.main.querySelector(".pe-cart-items");
      const subtotal = this.main.querySelector(
        "#main-cart-footer .totals__subtotal-value",
      );
      if (checkout !== this.checkout) {
        this.intersection.disconnect();
        this.checkout = checkout;
        this.checkoutVisible = true;
        if (checkout) this.intersection.observe(checkout);
      }
      const isEmpty =
        !items ||
        items.classList.contains("is-empty") ||
        !items.querySelector(".cart-item");
      this.hidden = isEmpty || !checkout || !subtotal || this.checkoutVisible;
      const amount = subtotal?.textContent.trim() || "";
      if (this.total.textContent !== amount) this.total.textContent = amount;
      this.button.disabled =
        this.loading ||
        !checkout ||
        checkout.disabled ||
        Boolean(
          this.main.querySelector(
            '.cart__items--disabled, cart-items[aria-busy="true"]',
          ),
        );
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.button?.removeEventListener("click", this.onClick);
      window.removeEventListener("pageshow", this.onPageShow);
      clearTimeout(this.loadingTimer);
      cancelAnimationFrame(this.frame);
    }
  }

  if (!customElements.get("pe-cart-delivery"))
    customElements.define("pe-cart-delivery", PeCartDelivery);
  if (!customElements.get("pe-cart-sticky"))
    customElements.define("pe-cart-sticky", PeCartSticky);
})();
